import React, { useRef } from 'react';
import { extend } from '@react-three/fiber';
import * as meshline from 'threejs-meshline';
import { a } from '@react-spring/three';
import { useHazeDrop, useHaze } from './use-haze';
extend(meshline);
export const Haze = (props) => {
    var _a;
    const haze = useRef();
    const mat = useRef();
    useHazeDrop(haze, mat, { value: props.value });
    return (React.createElement(a.mesh, { ref: haze, "material-opacity": (_a = props.style) === null || _a === void 0 ? void 0 : _a.opacity.to((x) => x * props.value.opacity) },
        React.createElement("meshLine", { attach: "geometry", vertices: props.value.vertices }),
        React.createElement("meshLineMaterial", { attach: "material", ref: mat, transparent: true, depthTest: false, sizeAttenuation: true, lineWidth: 0.01, dashArray: props.value.dashArray, dashRatio: 0.8, color: props.value.color })));
};
const Hazes = (props) => {
    const { lines } = useHaze(props);
    return (React.createElement(a.group, null, lines.map((haze, index) => {
        return React.createElement(Haze, { key: index, value: haze, style: props.style });
    })));
};
export default Hazes;
